import React, { Component } from 'react'
import {connect} from 'react-redux';
import  { Tab, Button, Label, Segment, Form, Divider, Pagination, Icon, Card, Modal, Message, Dropdown, Input } from 'semantic-ui-react';
import { HashRouter as Router, Link} from 'react-router-dom'
import {bindActionCreators} from 'redux';
import * as tokenActions from '../actions/actions';
import '../App.css'

import 'semantic-ui-css/semantic.min.css';
import '../App.css';
import '../index.css';
import { toast } from 'react-toastify';


/*
    This page allows renders the current user's account details.
    * Users can view thier organisation, Access Level.
    * Users can request to change thier Access Level. This will have to be apporoved by one of the selected administrators. 
    * User can request API keys for access to arboretum data. 
    * Users can vierw thier API keys. 
    * Users can reset thier password.
*/


class Account extends Component {
    constructor(props){
        super(props);
        this.state = {
            userName:props.userName,
            email:props.userEmail,
            emailSent:null,
            token:null,
            org:null,
            tokens:null,
            isFetching:false,
            orgs:[],
            roles:[],
            showSubmit:false,
            passPhrase:null,
            fetchedUser:false
        }

        this.requestNewToken = this.requestNewToken.bind(this);
        this.viewTokens = this.viewTokens.bind(this);
        this.generateData = this.generateData.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeRole = this.handleChangeRole.bind(this);
        this.handlePass = this.handlePass.bind(this);
        this.sendResetEmail = this.sendResetEmail.bind(this);  
        this.editUser = this.editUser.bind(this);
       

    }

componentWillReceiveProps(props){
    if(this.state.fetchedUser === false){
        //getting user info from db
        if(this.props.authenticated && this.props.userId){
            this.props.tokenActions.getUserInfo(this.props.userId);
            this.setState({fetchedUser:true})
        }
         
    }
    this.setState({userName:props.userName, email:props.userEmail})

    if(props.showTokenSuccessAlert || props.showTokenFailureAlert){
        if(props.showTokenSuccessAlert === true){
            toast("Token generation successfull");
            this.setState({token:props.token})
            this.setState({isFetching:false})
            this.setState({passPhrase:null})
        }
        if(props.showTokenFailureAlert === true){
            toast.error("Token generation unsuccessfull");
            this.setState({isFetching:false})
            this.setState({passPhrase:null})
            
        }
    }
    if(props.emailSuccess === true){
        this.setState({emailSent:true});
        toast("Email Sent Successfully");
    }
    if(props.emailSuccess === false){
        this.setState({emailSent:false});
        toast.error("Error! Make sure you have the correct email address!");
    }
    if(props.getTokenSuccessAlert === true){
        toast("Tokens retieved successfully");
        this.setState({tokens:props.tokens})
        this.setState({isFetching:false})
    }
    if(props.getTokenFailureAlert === true){
        toast.error("Token retrival unsuccessfull");
        this.setState({isFetching:false})
    }
    if(props.userInfoSuccess === true){
        this.setState({userMeta:props.userInfoData}, () =>{
            if(!this.state.userMeta || !this.state.userMeta.organisation){
                this.setState({noOrgMessage:"Your user account has not been approved yet. Please wait until you get an e-mail confirmation to access Roles and API functions."})
            }
            
        })
    } 
    if(props.userInfoSuccess === false){
        this.setState({userMeta:null})
    }
    if(props.editUserSuccess === true){
        toast.success("Change Requested Successfully!")
        this.setState({changeMessage:"Role Change request sent for review. You will recieve an email when your request has been approved."})
    }
    if(props.editUserSuccess === false){
        
        toast.error("Could not requst Access Level Chage!")
        this.setState({noOrgMessage:"There was an error requesting the change. Please try again later!"})
    }

    this.props.tokenActions.hideAlerts();


}
componentDidMount(){
    this.setState({
        orgs:[ { key: 'arb', value: 'arb',text: 'National Arboretum Canberra' }, { key: 'uc', value: 'uc',text: 'University of Canberra'}, { key: 'qc', value: 'qc',text: 'Queanbeyan City Council'}, { key: 'pa', value: 'pa',text: 'Public Access'} ],
        roles:[ { key: 'dev', value: null,text: 'Select Access Level' }, { key: 'dev', value: 'Developer',text: 'Developer' }, { key: 'uc', value: 'Client',text: 'Client'}, { key: 'qc', value: 'Admin',text: 'Admin'}, { key: 'pa', value: 'Superadmin',text: 'Super Admin'} ]
    })
    this.props && this.props.userId && this.props.tokenActions.getUserInfo(this.props.userId);
    
}
editUser(e){
    e.preventDefault();
    if(this.state.userMeta && this.state.userMeta.organisation && this.state.role){
        this.props.tokenActions.editUser(this.props.userId, this.state.role, this.state.userMeta.organisation, this.props.userName, this.props.userEmail)
        toast.info('Requesting Change.. ')
    } else if((this.state.userMeta && this.state.userMeta.organisation) && !this.state.role){
        toast.warning('Please Fill in the intended access level!')
    }else if((!this.state.userMeta || !this.state.userMeta.organisation) && this.state.role ){
        toast.info('Registration Pending!')
        this.setState({noOrgMessage:"Your user account has not been approved yet. Please wait until you get an e-mail confirmation to access Roles and API functions."})
    } else{
        toast.warning('Pleae fill in the required fields!')
    }


}

handleChange(e){
    var value = e.target.innerText;
        if(value){
            this.setState({org:value})
            this.setState({showSubmit:true}) 
    
        }
        else{
            this.setState({showSubmit:false})
        }

}

handleChangeRole(e, data){
    e.preventDefault();
    let value = data.value;;
        if(value){
            this.setState({role:value})
        }

}
handlePass(e){
    this.setState({passPhrase:e.target.value})
}


requestNewToken(e){
    e.preventDefault();
    if(this.state.userMeta && this.state.userMeta.organisation){
        let org = this.state.userMeta && this.state.userMeta.organisation;
        this.props.tokenActions.newToken(this.props.userName, this.props.userId, org);
        toast.warning("Requesting Token!");
    } else{
        toast.info("Organisation data unavailable. Please wait for your account approval!");
    }
    
    
    
    

}
viewTokens(e){
    e.preventDefault();
    this.setState({isFetching:true});
    toast.warning('Fetching Data');
    this.props.tokenActions.getTokens(this.props.userId);
    
}
generateData(val){

   var tokenFields = [];
   var tokenArray = val;
    var i = 0; 
    if (this.state.token){
        for (i; i < tokenArray.length; i++){
            if(i !== 99 ){    
                tokenFields.push(  
                    <Label>{tokenArray[i]}</Label> 
                );
            }
        }
        
        return tokenFields;

    }

}
generateData1(val){
    
    var tokensFields = [];
    // var tokensArray = val;
    
    
    if (this.state.tokens){

    // val = String(val[7]['token'])
    for (var j  = 0; j < val.length; j++){

        tokensFields.push(  
            <Label color='green' tiny style={{margin:"6px", textAlign:"center", display:"block"}}>{val[j]['token']}</Label>
        )
        

 
    }
    tokensFields.push(
        <div style={{textAlign:"center"}}>
            <Pagination
                defaultActivePage={1}
                firstItem={null}
                lastItem={null}
                pointing
                secondary
                totalPages={1}
            />
        </div>

    )

    return tokensFields;
    
    }
    else{
        return tokensFields;
    }
 }

 sendResetEmail(e){
    e.preventDefault();
    this.props.tokenActions.sendResetEmail(this.state.email);
 }


    render() {
        // const {userName} = this.state;
        const extra = (
            <a>
              <Icon name='user' />
              {(this.state.userMeta && this.state.userMeta.organisation) || 'No Organisation(s) found'}
            </a>
          )
        
        const panes = [
            { menuItem: 'Account Settings', render: () => 
                <Tab.Pane attached={false}>
                <div className = 'ui stackable two column grid'>
                    <Card className='six wide column'
                        image='../../photo.1.png'
                        header={this.state.userName}
                        meta={((this.state.userMeta && this.state.userMeta.accessLevel) || 'User') + ' Level Access'}  
                        extra={extra}
                    />
                    <div className='ten wide column'>
                        <h4>Edit Access Level</h4>
                        <Form onSubmit = {this.editUser}>
                        <Form.Field>
                            <label>Organisation</label>
                            <Input disabled placeholder='Select Organisation' value={(this.state.userMeta && this.state.userMeta.organisation) || "No Org"} />  
                        </Form.Field>           
                        <Form.Field>
                            <label>Access Level</label>
                            <Dropdown onChange={this.handleChangeRole}placeholder='Select Access Level' fluid search selection options={this.state.roles} />  
                        </Form.Field>
                        <Button content='Submit Request' primary type='submit'/>
                        </Form>
                    </div>
                    {this.state.changeMessage ? <Message style={{textAlign:'center', width:'100%'}}fluid size='tiny' positive  content={this.state.changeMessage}/> : null}
                    {this.state.noOrgMessage ? <Message style={{textAlign:'center', width:'100%'}}fluid size='tiny' negative  content={this.state.noOrgMessage}/> : null}
                    
                </div>
    
                {/* <Button content='Edit Details'/> */}
                
              

                <Label attached = 'bottom right'color='red'>
                        <a href="/#/reset">Reset Password</a>
                </Label>

                <Modal  size='small' closeIcon trigger={<Label attached = 'bottom right'color='red'><a>Reset Password</a></Label>}>
                    <Modal.Header>Confirm Password Reset</Modal.Header>
                    <Modal.Content>
                        <p>
                            An email will be sent to your email address linked to this account.
                            
                        </p>
                        <Message>{this.state.email}</Message>
                        {this.state.emailSent === true ? <Label inverted>Email Sent! Please check your email for reset instructions.</Label> : null}
                    </Modal.Content>
                    <Modal.Actions>

                        <Button color='red' inverted onClick={this.sendResetEmail}>
                            <Icon name='checkmark' /> Reset
                        </Button>
                    </Modal.Actions>
                </Modal>    
                
                
                </Tab.Pane>
                
            },
            { menuItem: 'API Settings', render: () =>

                <Tab.Pane attached={false}> 
                    

                    <Modal trigger={<Button primary content = 'Request an API key'/>} closeIcon>
                        <Modal.Header>API Key Request</Modal.Header>
                        <Modal.Content>
                        <Modal.Description>
                            {/* <Header>Modal Header</Header> */}
                            <p>An API key/token will provide read/write acces to the database.</p>
                            <p> 
                                The gateway  in your senor network will require this key to be able to upload the generated data.
                                If you revoke or delete a key, you will need to request a new key and update the gateway with it.
                            </p>
                            <Message error size = 'tiny' content = 'Do not share this key !'/>
                            
                            {(this.state.token ?
                                (
                                    <div className='ui message'>
                                        Your new access token: <Label size='small'> {this.generateData(this.state.token)} </Label>
                                    </div>
                                ):null
                            )}


                        </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            
                        <Button primary onClick={this.requestNewToken} >
                            Submit Request <Icon name='right chevron' />
                        </Button> 
        
                        </Modal.Actions>
                    </Modal>



                    {(this.state.token ?
                        (
                            <div className='ui message'>
                                Your new access token: <Label size='small'> {this.generateData(this.state.token)} </Label>
                            </div>
                        ):null
                    )}

                       
                    <Button content = 'View my API keys' onClick={this.viewTokens} />
                    <Divider/>
                        {this.generateData1(this.state.tokens)}
                       {(this.state.isFetching) ? (<Icon loading name='spinner' />):(null)}
                </Tab.Pane>
                
            },
          ]

      return (
        <div className = 'normal-left'>
         
            <h3>{this.state.userName}</h3>
           
           
            {
                
                (this.props.authenticated) ? 
                (<Tab  panes={panes} defaultActiveIndex={0} />)
                :
                (
                <Router>
                    <Segment raised>
                    
                        <Label color='orange' as={Link} to ={'/login'} ribbon>
                            Log In
                        </Label>
                        Please Sign Up or Log In to Access Account Settings.
                    </Segment>
                </Router>)
            
            }   
        </div>
        
      )
    }
}

function mapStateToProps(state) {
    return {
        ...state.initState
    };
}
function mapDispatchToProps(dispatch) {
    return {
        tokenActions: bindActionCreators(tokenActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    
)(Account);



// WEBPACK FOOTER //
// ./src/components/account.js